import "./index.scss";
import { ReactComponent as Star } from "assets/images/star.svg";
import { ReactComponent as StarPartial } from "assets/images/star-partial.svg";
import appStore from "assets/images/footer/app-store.png";
import playStore from "assets/images/footer/play-store.png";
import { EXTERNAL_LINKS } from "routes/paths";

export const PortalFooterDownload = () => {
  return (
    <div className="portal-footer-download">
      <div className="app-download">
        <h2>Download the GCX App</h2>
        <h3>Shop, save and redeem your cards on the go.</h3>
        <div className="download-buttons">
          <a
            href={EXTERNAL_LINKS.DOWNLOAD_APP_STORE}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="app-store"
              alt="Download on the App Store"
              src={appStore}
              width="88"
              height="26"
              loading="lazy"
            />
          </a>
          <a
            href={EXTERNAL_LINKS.DOWNLOAD_PLAY_STORE}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="play-store"
              alt="Get it on Google Play"
              src={playStore}
              width="88"
              height="26"
              loading="lazy"
            />
          </a>
        </div>
        <div className="download-ranking">
          <div className="app-stars">
            {[...Array(4)].map((_, index) => (
              <Star key={index} />
            ))}
            <StarPartial />
          </div>
          4.8 Stars
        </div>
      </div>
    </div>
  );
};
